// extracted by mini-css-extract-plugin
export default {"grid":"FeaturesExtra_grid__C4UVV","card":"FeaturesExtra_card__QRZ-k","future":"FeaturesExtra_future__cFHsA","badge":"FeaturesExtra_badge__ElDou"};